import { jsx } from "react/jsx-runtime";
import B2BLayout from "../B2BLayout/B2BLayout.esm.js";
import { LAYOUT_MENU_ITEMS, LAYOUT_MENU_ITEM_IDS } from "./constants/layout.esm.js";
import RentalsLogo from "./images/rentals-logo.svg.esm.js";
const img = {
  src: RentalsLogo,
  width: 215,
  height: 25,
  blurHeight: 0,
  blurWidth: 0
};
const RentalsLayout = ({
  children,
  submenu,
  header,
  router,
  environment
}) => {
  return /* @__PURE__ */ jsx(B2BLayout, { router, env: environment, signInLink: "/rental-manager/login/", signInRedirectParam: "url", userMenuItems: [{
    label: "Inbox",
    url: "https://www.zillow.com/rental-manager/inbox"
  }], menu: LAYOUT_MENU_ITEMS, submenu, transparent: header == null ? void 0 : header.transparent, disabled: header == null ? void 0 : header.disabled, primaryCTALabel: "Post your listing", primaryCTALink: "/rental-manager/properties?postingPath=true", secondaryCTALabel: "Contact sales", secondaryCTALink: "/rentals-network/contact-sales/", logo: {
    ...img,
    alt: "Zillow Rentals Logo",
    link: "/rental-manager/"
  }, footerColumns: [{
    title: "Rental manager",
    links: [...LAYOUT_MENU_ITEMS.filter((item) => item.id === LAYOUT_MENU_ITEM_IDS.RentalManager).map(convertMenuItemToFooterLink), ...LAYOUT_MENU_ITEMS.filter((item) => item.parent === LAYOUT_MENU_ITEM_IDS.RentalManager).map(convertMenuItemToFooterLink)]
  }, {
    title: "Apartment advertising",
    links: [...LAYOUT_MENU_ITEMS.filter((item) => item.id === LAYOUT_MENU_ITEM_IDS.ApartmentAdvertising).map(convertMenuItemToFooterLink), ...LAYOUT_MENU_ITEMS.filter((item) => item.parent === LAYOUT_MENU_ITEM_IDS.ApartmentAdvertising).map(convertMenuItemToFooterLink)]
  }], children });
};
function convertMenuItemToFooterLink(item) {
  return {
    title: item.parent === 0 ? "Overview" : item.title.rendered,
    url: item.url
  };
}
export {
  RentalsLayout as default
};
